// src/components/ErrorBoundary.js
// Atrapa los errores de render de una sección para que, si algo falla, solo esa
// parte muestre un aviso y el resto del portal (menú, otras tarjetas) siga funcionando.
import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`Error en ${this.props.titulo || "una sección"}:`, error, info?.componentStack);
  }

  // Al cambiar resetKey (p. ej. otra ruta) se vuelve a intentar mostrar el contenido.
  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    const { titulo = "esta sección" } = this.props;

    return (
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 flex items-start gap-3">
        <span className="w-8 h-8 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center shrink-0">
          <FaExclamationTriangle className="text-sm" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-800">No se pudo mostrar {titulo}</p>
          <p className="text-xs text-slate-500 mt-0.5">El resto del portal sigue funcionando. Intenta de nuevo o recarga la página.</p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="mt-3 px-3 py-1.5 text-xs font-medium rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }
}
